var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4868 16.71L19.7268 17.85C19.9543 18.8356 19.7297 19.8713 19.1145 20.6742C18.4993 21.4771 17.5577 21.9633 16.5468 22H7.26683C6.25601 21.9633 5.3144 21.4771 4.69918 20.6742C4.08396 19.8713 3.8594 18.8356 4.08683 17.85L4.32683 16.71C4.60287 15.1668 5.92945 14.0327 7.49683 14H16.3168C17.8842 14.0327 19.2108 15.1668 19.4868 16.71ZM16.5468 20.49C17.0546 20.4841 17.5325 20.2489 17.8468 19.85V19.86C18.2325 19.3762 18.3828 18.7458 18.2568 18.14L18.0168 17C17.8837 16.1552 17.1715 15.5226 16.3168 15.49H7.49684C6.6422 15.5226 5.93 16.1552 5.79684 17L5.55684 18.14C5.43399 18.7426 5.5841 19.3687 5.96684 19.85C6.28117 20.2489 6.75905 20.4841 7.26684 20.49H16.5468Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4063 12H11.4063C9.19713 12 7.40626 10.2092 7.40626 8.00001V5.36001C7.4036 4.46807 7.75674 3.61189 8.38744 2.98119C9.01814 2.35049 9.87432 1.99735 10.7663 2.00001H13.0463C13.9382 1.99735 14.7944 2.35049 15.4251 2.98119C16.0558 3.61189 16.4089 4.46807 16.4063 5.36001V8.00001C16.4063 10.2092 14.6154 12 12.4063 12ZM10.7663 3.50002C9.73902 3.50002 8.90627 4.33277 8.90627 5.36001V8.00001C8.90627 9.38073 10.0256 10.5 11.4063 10.5H12.4063C13.787 10.5 14.9063 9.38073 14.9063 8.00001V5.36001C14.9063 4.86671 14.7103 4.39361 14.3615 4.0448C14.0127 3.69598 13.5396 3.50002 13.0463 3.50002H10.7663Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.acc20eb5.svg";
export { ForwardRef as ReactComponent };